export class StandingOrderEntity {
  constructor() {
    this.id = null;
    this.fromAccountName = null;
    this.fromAccountId = null;
    this.toAccountName = null;
    this.frequency = null;
    this.sortCode = null;
    this.reference = null;
    this.payType = null;
    this.category = null;
    this.accountNumber = null;
    this.isSoWrite = null;
    this.soType = null;
    this.when = null;
    this.type = null;
    this.amount = null;
    this.singleData = null;
    this.scheduleData = null;
    this.paymentType = null;
  }
  getManagePayment() {
    return this;
  }
  getManagePaymentId() {
    return this.id;
  }
  setManagePaymentId(accountId) {
    this.id = accountId;
  }
}
export default StandingOrderEntity;
